import React, { useEffect, useRef, useState } from 'react';

import s from './styles.module.scss';

import type { ReactNode } from 'react';

type MarqueeProps = {
  text: ReactNode | string;
};

export const Marquee = ({ text }: MarqueeProps) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const groupRef = useRef<HTMLDivElement>(null);
  const [repeat, setRepeat] = useState(2);

  useEffect(() => {
    const container = containerRef.current;
    const group = groupRef.current;
    if (!container || !group) return;

    const calc = () => {
      const containerWidth = container.offsetWidth;
      const groupWidth = group.scrollWidth;
      if (!groupWidth) return;

      const needed = Math.ceil(containerWidth / groupWidth) + 2;
      setRepeat(needed);
      container.style.setProperty('--group-width', `${groupWidth}px`);
    };

    calc();
    const ro = new ResizeObserver(calc);
    ro.observe(container);
    ro.observe(group);

    return () => ro.disconnect();
  }, [text]);

  return (
    <div ref={containerRef} className={s.marquee} data-marquee>
      <div className={s.track}>
        {Array.from({ length: repeat }).map((_, i) => (
          <div key={i} ref={i === 0 ? groupRef : undefined} className={s.group}>
            {Array.from(Array(5).keys()).map((_num, index) => {
              return (
                <span key={index} className={s.text}>
                  {text}
                </span>
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );
};
